module.exports = __webpack_public_path__ + "assets/img/all_ucon.2cd5fb81.svg";